// ReduxEvent holds all the action type constants used across Redux for consistent usage
export const ReduxEvent = {
  // Triggered when a user successfully signs in
  SIGNIN_SUCCESS: "SIGNIN_SUCCESS",

  // Triggered when a user successfully signs out
  SIGNOUT_SUCCESS: "SIGNOUT_SUCCESS",

  // Indicates that a loading state is active (e.g., API call in progress)
  LOADING: "LOADING",

  // Used when external data is injected into the state (e.g., from an API or third-party source)
  USE_EXTERNAL_DATA_SET: "USE_EXTERNAL_DATA_SET",

  // Stores or updates parameters related to a user persona
  PERSONA_PARAMS: "PERSONA_PARAMS",

  // Sets the currently selected persona in the application
  SELECTED_PERSONA: "SELECTED_PERSONA",
};
